import { AntInput, AntPasswordInput } from './styles'

export default AntInput
export { AntPasswordInput }
